/**
 * Flag de debug do sistema de plugins (UI).
 *
 * Liga/desliga os logs de diagnóstico do runtime de plugins (PluginWrap,
 * controladores de slot, registro, etc.) sem precisar adicionar/remover
 * console.log no código.
 *
 * Como ativar (qualquer um):
 *  - no browser: `localStorage.setItem("mk:plugin-debug", "1")` e recarregar;
 *    ou em runtime: `window.__mkPluginDebug = true`
 *  - programaticamente: `setPluginDebug(true)`
 *
 * Os scripts serializados de plugin (frontendScript) também podem checar via
 * `window.__mkPluginDebug`.
 */

let enabled = false;

function readInitial(): boolean {
  try {
    const g: any = typeof globalThis !== "undefined" ? globalThis : {};
    if (g.__mkPluginDebug === true) return true;
    if (g.localStorage && g.localStorage.getItem("mk:plugin-debug") === "1") return true;
  } catch { /* SSR/Node: sem window */ }
  return false;
}

enabled = readInitial();

/** Liga/desliga o debug em runtime. Persiste no localStorage (sobrevive a reload). */
export function setPluginDebug(on: boolean): void {
  enabled = !!on;
  try {
    const g: any = typeof globalThis !== "undefined" ? globalThis : {};
    g.__mkPluginDebug = enabled;
    if (g.localStorage) {
      if (enabled) g.localStorage.setItem("mk:plugin-debug", "1");
      else g.localStorage.removeItem("mk:plugin-debug");
    }
  } catch { /* noop */ }
}

/** Estado atual do debug (relê window/localStorage para refletir mudanças). */
export function isPluginDebug(): boolean {
  return enabled || readInitial();
}

/** console.log condicional — só imprime se o debug estiver ligado. */
export function pluginLog(...args: any[]): void {
  if (!isPluginDebug()) return;
  // eslint-disable-next-line no-console
  try { console.log("[plugin]", ...args); } catch { /* noop */ }
}
